import React from 'react';
import { Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';

export const EmployeeInfoField: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => {
  return (
    <Flex>
      <Stack x="xx-sm" y="xx-sm">
        <Copy variant="body" strong>
          {label}:
        </Copy>
      </Stack>
      <Copy variant="body">{value}</Copy>
    </Flex>
  );
};
